import {Map, List} from 'immutable';
import {Basic} from '@packages/systems/core/plugins';
import {Atom} from '@packages/systems/wfdl';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';

const staticBindings = Map({
  for: List([
    Map({
      slug: 'id',
      type: 'PlainText',
    }),
  ]),
});

const config = createIntegratedAtom({
  displayName: 'Shipping Method Name Block',
  showEmpty: true,
  constraints: {
    ancestors: [{is: 'CommerceCheckoutShippingMethodItem', rule: 'ExactlyOne'}],
  },
  style: {
    base: {
      main: {
        noPseudo: {
          fontWeight: 700,
        },
      },
    },
  },
  render: Atom.getConfigShape(Basic.atoms.Block).render,
  staticBindings,
  fields: {},
});

export default config;
